import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../envelope/Sidebar';
import TopBar from '../envelope/TopBar';
import './ResultsPage.css';

const ResultsPage = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [activeTests, setActiveTests] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [groups, setGroups] = useState([]);
  const [userCompanyId, setUserCompanyId] = useState(null);
  

const getTagClass = (type) => {
  if (type === 'sociometry') {
    return 'test-tag test-tag-sociometry';
  } else if (type === 'leadership') {
    return 'test-tag test-tag-leadership';
  } else if (type === 'belben') {
    return 'test-tag test-tag-teamrole';
  }
  return 'test-tag';
};

  // Состояния для фильтров и поиска
  const [tagFilters, setTagFilters] = useState({
    sociometry: false,
    leadership: false,
    teamRole: false
  });
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearchActive, setIsSearchActive] = useState(false);

  // Загрузка активных тестирований
  const fetchActiveTests = async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        throw new Error('Токен авторизации не найден');
      }

      const response = await fetch('http://185.250.149.189:8000/api/v1/Test', {
        headers: {
          'Authorization': `Token ${token}`,
        }
      });
      
      if (!response.ok) {
        throw new Error(`Ошибка HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      console.log (data);
      return data.tests || [];
      
    } catch (error) {
      console.error('Ошибка загрузки активных тестирований:', error);
      setError(error.message);
      return [];
    }
  };

  // Загрузка групп
  const fetchGroups = async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        throw new Error('Токен авторизации не найден');
      }

      const response = await fetch('http://185.250.149.189:8000/api/v1/GroupUsers', {
        headers: {
          'Authorization': `Token ${token}`,
        }
      });
      
      if (!response.ok) {
        throw new Error(`Ошибка HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      
      // Извлекаем группы из ответа
      let groupsArray = [];
      if (Array.isArray(data)) {
        groupsArray = data;
      } 
      else if (data.groups_users && Array.isArray(data.groups_users)) {
        groupsArray = data.groups_users;
      }
      else if (data.groups && Array.isArray(data.groups)) {
        groupsArray = data.groups;
      }
      else if (data.results && Array.isArray(data.results)) {
        groupsArray = data.results;
      }
      
      return groupsArray;
      
    } catch (error) {
      console.error('Ошибка загрузки групп:', error);
      return [];
    }
  };

  // Загрузка company_id пользователя
  const fetchCompanyId = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch('http://185.250.149.189:8000/api/v1/Company', {
        headers: {
          'Authorization': `Token ${token}`,
        }
      });
      
      if (!response.ok) {
        throw new Error(`Ошибка HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      return data.Company?.id || null;
      
    } catch (error) {
      console.error('Ошибка загрузки компании:', error);
      return null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        // Загружаем данные параллельно
        const [companyId, testsData, groupsData] = await Promise.all([
          fetchCompanyId(),
          fetchActiveTests(),
          fetchGroups()
        ]);
        
        setUserCompanyId(companyId);
        setActiveTests(testsData);
        setGroups(groupsData);
        
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchData();
  }, []);

  // Фильтрация тестов по company_id
  const filteredTests = userCompanyId === 1
    ? activeTests
    : activeTests.filter(test => test.company?.id === userCompanyId);

  // Функция для получения названия группы по ID
  const getGroupName = (groupId) => {
    if (!groupId) return 'Не указана';
    
    const group = groups.find(g => g.id == groupId);
    return group ? group.name : 'Не указана';
  };

  // Обработчик клика по карточке теста
  const handleTestClick = (testId) => {
    navigate(`/results/${testId}`);
  };

  const getQuestionType = (question) => {
    return question.quest_type || question.question_type || 'unknown';
  };

  // Функция для получения уникальных типов вопросов
  const getUniqueQuestionTypes = (questions) => {
    if (!questions || questions.length === 0) return [];
    
    const types = new Set();
    questions.forEach(question => {
      const type = getQuestionType(question);
      if (type) {
        types.add(type);
      }
    });
    return Array.from(types);
  };

  // Преобразование типа вопроса в читаемое название
  const getQuestionTypeName = (type) => {
    switch(type) {
      case 'sociometry': return 'Социометрия';
      case 'leadership': return 'Лидерство';
      case 'belben': return 'Роли в команде';
      default: return type;
    }
  };

  // Фильтрация по тегам
  const filterByTags = (tests) => {
    // Если ни один фильтр не выбран - возвращаем все
    if (!tagFilters.sociometry && !tagFilters.leadership && !tagFilters.teamRole) {
      return tests;
    }
    
    return tests.filter(test => {
      if (!test.questions || test.questions.length === 0) return false;
      
      const types = getUniqueQuestionTypes(test.questions);
      
      // Проверяем соответствие каждому фильтру
      const hasSociometry = tagFilters.sociometry && types.includes('sociometry');
      const hasLeadership = tagFilters.leadership && types.includes('leadership');
      const hasTeamRole = tagFilters.teamRole && types.includes('belben');
      
      return hasSociometry || hasLeadership || hasTeamRole;
    });
  };

  // Фильтрация по поисковому запросу
  const filterBySearch = (tests) => {
    if (!searchQuery.trim()) return tests;
    
    const queryWords = searchQuery.toLowerCase().split(/\s+/);
    
    return tests.filter(test => {
      const name = test.name?.toLowerCase() || '';
      
      // Проверяем, что все слова из запроса присутствуют в названии
      return queryWords.every(word => name.includes(word));
    });
  };

  // Применяем все фильтры
  const filteredByTags = filterByTags(filteredTests);
  const filteredAndSearchedTests = filterBySearch(filteredByTags);

  // Обработчик изменения фильтров
  const handleTagFilterChange = (filterName) => {
    setTagFilters(prev => ({
      ...prev,
      [filterName]: !prev[filterName]
    }));
  };

  // Обработчик поиска
  const handleSearch = (e) => {
    if (e.key === 'Enter' || e.type === 'click') {
      setIsSearchActive(true);
    }
  };

  // Обработчик сброса поиска
  const handleClearSearch = () => {
    setSearchQuery('');
    setIsSearchActive(false);
  };

  return (
    <div className="dashboard">
      <Sidebar 
        isCollapsed={isSidebarCollapsed} 
        toggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
      />
      <TopBar isCollapsed={isSidebarCollapsed} />  
      <main className={`main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="content-container">
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            marginBottom: '30px' 
          }}>
            <h1>Результаты тестирований</h1>
          </div>

          {/* Панель фильтров и поиска */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between',
            marginBottom: '20px',
            gap: '15px',
            flexWrap: 'wrap'
          }}>
            {/* Поле поиска */}
            <div style={{ 
              position: 'relative',
              width: '300px',
              height: '36px'
            }}>
              <input
                type="text"
                placeholder="Введите название теста"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyPress={handleSearch}
                style={{
                  width: '100%',
                  height: '100%',
                  padding: '0 40px 0 15px',
                  border: '0.5px solid #CCD3DE',
                  borderRadius: '8px',
                  backgroundColor: 'transparent',
                  fontFamily: '"Montserrat", sans-serif',
                  fontSize: '14px',
                  color: '#2c3e50'
                }}
              />
              <div 
                onClick={handleSearch}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer'
                }}
              >
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#7F8C8D"/>
                </svg>
              </div>
              
              {isSearchActive && (
                <div 
                  onClick={handleClearSearch}
                  style={{
                    position: 'absolute',
                    right: '35px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    color: '#7F8C8D',
                    fontSize: '18px'
                  }}
                >
                  ×
                </div>
              )}
            </div>
            
            <div style={{ 
              display: 'flex', 
              gap: '15px',
              flexWrap: 'wrap',
              justifyContent: 'flex-end'
            }}>
              {/* Фильтры по тегам */}
              <div style={{ 
                display: 'flex', 
                gap: '15px',
                backgroundColor: '#f8f9fa',
                padding: '10px 15px',
                borderRadius: '8px'
              }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <input 
                    type="checkbox"
                    checked={tagFilters.sociometry}
                    onChange={() => handleTagFilterChange('sociometry')}
                  />
                  Социометрия
                </label>
                
                <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <input 
                    type="checkbox"
                    checked={tagFilters.leadership}
                    onChange={() => handleTagFilterChange('leadership')}
                  />
                  Лидерство
                </label>
                
                <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <input 
                    type="checkbox"
                    checked={tagFilters.teamRole}
                    onChange={() => handleTagFilterChange('teamRole')}
                  />
                  Роль в команде
                </label>
              </div>
            </div>
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          {isLoading ? (
            <div style={{ textAlign: 'center', padding: '50px 0' }}>
              <p>Загрузка данных...</p>
            </div>
          ) : filteredAndSearchedTests.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '50px 0' }}>
              <p style={{ fontSize: '18px', color: '#666' }}>
                {searchQuery || tagFilters.sociometry || tagFilters.leadership || tagFilters.teamRole
                  ? 'Тесты по выбранным фильтрам не найдены'
                  : userCompanyId === 1
                    ? 'Активные тестирования не найдены'
                    : 'Для вашей компании активные тестирования не найдены'
                }
              </p>
            </div>
          ) : (
<div className="test-result-cards-container">
  {filteredAndSearchedTests.map(test => (
    <div className="test-card-wrapper" key={test.id}>
      <div 
        className="test-card"
        onClick={() => handleTestClick(test.id)}
      >
                    <div className="test-card-header">
                      <h3 className="test-card-title">{test.name}</h3>
                    </div>
                    
                    <div className="test-card-description">
                      {test.description || 'Описание отсутствует'}
                    </div>
                    
                    <div className="test-card-meta">
                      <div className="meta-item">
                        <span className="meta-label">Группа:</span>
                        <span className="meta-value">
                          {getGroupName(test.group?.id)}
                        </span>
                      </div>
                      <div className="meta-item">
                        <span className="meta-label">Участников:</span>
                        <span className="meta-value">{test.group?.users?.length || 0}</span>
                      </div>
                      <div className="meta-item">
                        <span className="meta-label">Вопросов:</span>
                        <span className="meta-value">{test.questions?.length || 0}</span>
                      </div>
                    </div>
                    
<div className="test-card-types">
  {test.questions && test.questions.length > 0 ? (
    getUniqueQuestionTypes(test.questions).map((type, index) => (
      <span key={index} className={getTagClass(type)}>
        {getQuestionTypeName(type)}
      </span>
    ))
  ) : (
    <span className="test-tag">Нет вопросов</span>
  )}
</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default ResultsPage;